<template>
  <SweetTable ref="table" :height="maxTableHeight" url="/trade/factorymake/detail/list" :is-page="false"
              :before-table-binding="beforeTableBinding" :query-form="dataForm"
              :summaries-column="['count','checkInCount','checkOutCount','storeCount','preBoxCount','totalPrice','totalAmount']">
    <el-table-column label="品番号" width="160" prop="code" header-align="center" align="center" fixed="left"
                     :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="SKU" width="100" prop="skuCode" header-align="center" align="center" fixed="left"
                     :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="品名" align="center" prop="name" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="中文品名" align="center" prop="nameZh" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column
        label="颜色"
        prop="color"
        header-align="center"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
    >
    </el-table-column>
    <el-table-column
        label="规格"
        prop="size"
        header-align="center"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
    >
    </el-table-column>
    <el-table-column
        prop="harbour"
        label="港口"
        header-align="center"
        align="center"
        width="100" :show-overflow-tooltip="true"
    ></el-table-column>
    <el-table-column
        prop="count"
        label="合同计划数"
        header-align="center"
        align="center"
        width="100"
    ></el-table-column>
    <el-table-column
        prop="checkInCount"
        label="入库数"
        header-align="center"
        align="center"
    ></el-table-column>
    <el-table-column
        prop="checkOutCount"
        label="出库数"
        header-align="center"
        align="center"
    ></el-table-column>
    <el-table-column
        prop="storeCount"
        label="剩余库存"
        header-align="center"
        align="center"
    ></el-table-column>
<!--    <el-table-column-->
<!--        prop="preBoxCount"-->
<!--        label="每箱入数"-->
<!--        header-align="center"-->
<!--        align="center"-->
<!--    ></el-table-column>-->
    <el-table-column
        label="加工费单价"
        header-align="center"
        align="center"
        prop="amount"
        width="100"
    >
    </el-table-column>
    <el-table-column
        label="包装检品费"
        header-align="center"
        align="center"
        prop="checkAmount"
        min-width="90"
    >
    </el-table-column>
    <el-table-column
        label="纸箱"
        header-align="center"
        align="center"
        prop="packPrice"
    >
    </el-table-column>
    <el-table-column
        label="中棉"
        header-align="center"
        align="center"
        prop="cottonPrice"
    >
    </el-table-column>
    <el-table-column
        label="运费"
        header-align="center"
        align="center"
        prop="freightPrice"
    >
    </el-table-column>
    <el-table-column
        label="综合单价"
        header-align="center"
        align="center"
        prop="totalPrice"
    >
    </el-table-column>

    <el-table-column
        label="加工费总额"
        header-align="center"
        align="center"
        prop="totalAmount"
        width="110"
        fixed="right"
    >
    </el-table-column>
  </SweetTable>
</template>

<script>
//TODO:计划删除
import BigNumber from 'bignumber.js'
import MakeChargeService from '@/service/make/MakeChargeService'
import SweetTable from '@/mixins/SweetTable'

export default {

  mixins: [SweetTable],
  components: {},
  props: {
    parentId: {
      type: String,
      default: '',
    },
    maxTableHeight: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      statusType: {
        10: '',
        20: 'warning',
        30: 'success',
      },
      dataForm: {
        parentId: '',
      },
    }
  },
  watch: {
    parentId: {
      handler: function (newVal) {
        if (!newVal) {
          this.$refs.table.dataList = []
          return
        }
        this.dataForm.parentId = newVal
        this.getDataList()
      },
      immediate: true,
    },
  },
  computed: {

  },
  methods: {
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        //计算剩余库存数
        const checkInCount = new BigNumber(row.checkInCount || 0)
        const checkOutCount = new BigNumber(row.checkOutCount || 0)
        row.storeCount = checkInCount.minus(checkOutCount).toString()
        row.totalAmount = new BigNumber( row.totalPrice).multipliedBy(checkInCount).toFixed(2)
      })
    }
  },
}
</script>
